import { PresentationTreeResponse, TaxonomyChild, TaxonomyRoot } from 'entities/tag';

export function pruneToUsedConcepts(data: PresentationTreeResponse | null | undefined, usedConceptNames: Set<string>): PresentationTreeResponse | null {
  if (!data) return null;
  if (!data.presentationTree) return data;

  const pruneChild = (node: TaxonomyChild): TaxonomyChild | null => {
    const prunedChildren = (node.children ?? []).map(pruneChild).filter((n): n is TaxonomyChild => n !== null);
    if (usedConceptNames.has(node.id) || prunedChildren.length > 0) {
      return { ...node, children: prunedChildren };
    }
    return null;
  };

  const pruneRoot = (root: TaxonomyRoot): TaxonomyRoot | null => {
    const prunedChildren = (root.children ?? []).map(pruneChild).filter((n): n is TaxonomyChild => n !== null);
    if (usedConceptNames.has(root.id) || prunedChildren.length > 0) {
      return { ...root, children: prunedChildren };
    }
    return null;
  };

  const networks = data.presentationTree.networks
    .map((network) => ({ ...network, roots: (network.roots ?? []).map(pruneRoot).filter((r): r is TaxonomyRoot => r !== null) }))
    .filter((network) => network.roots.length > 0);

  return { ...data, presentationTree: { ...data.presentationTree, networks } };
}
